import React, {Component} from 'react';
import Popup from '../modal/PopupDialog';
import _ from 'underscore';
import POS from '../../POS';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

class ItemSelector extends Component {
    constructor(props) {
        super(props);
        let chooseValue = "";
        if(props.allItems){
            this.props.items.forEach((item, index) => {
                chooseValue += item.id;
                if (index !== this.props.items.chooseItems - 1) {
                    chooseValue += ",";
                }
            });
        }else{
            this.props.chooseItems.forEach((item, index) => {
                chooseValue += item.id;
                if (index !== this.props.items.chooseItems - 1) {
                    chooseValue += ",";
                }
            });
        }
        this.state = {value: chooseValue};
        this.onChange = this.onChange.bind(this);
    }

    onChange(value) {
        let chooseValue = value;
        if (value.contains("all")) {
            chooseValue = "";
            this.props.items.forEach((item, index) => {
                chooseValue += item.id;
                if (index !== this.props.items.length - 1) {
                    chooseValue += ",";
                }
            });
        }
        this.setState({value: chooseValue});
        if (this.props.onAddItem) {
            console.log("select value = ", value);
            this.props.onAddItem(value.contains("all") ? 'all' : chooseValue);
        }
    }

    render() {
        const {value} = this.state;
        const items = value.split(",").length === this.props.items.length ? [] : [{label: "全选", value: "all"}];
        this.props.items.forEach((item) => {
            items.push({label: item.get("name"), value: item.id});
        });
        return (
            <div>
                <Select
                    options={items}
                    onChange={this.onChange}
                    value={value}
                    multi
                    simpleValue
                    removeSelected={true}
                    placeholder="选择标签"
                    closeOnSelect={false}
                />
            </div>
        )
    }

    // render() {
    //     return (
    //         <div>
    //             <Select style={{width: '80%', display: 'inline-block'}} className="form-control"
    //                     onChange={this.onChange}>
    //                 <option key="null" value={null}>--</option>
    //                 <option key="all" value="all">所有餐品</option>
    //                 {this.props.items.map(item =>
    //                     <option key={item.id} value={item.id}>{item.get('name')}</option>)}
    //             </Select>
    //             <div className="btn btn-primary" style={{marginLeft: 10}} onClick={this.addItem}>添加</div>
    //         </div>
    //     )
    // }
}

class CategoryView extends Component {
    constructor(props) {
        super(props);
        const categorySize = props.category.getMenuItems().length;
        let allItems = props.allItems;
        let items = props.items ? props.items : [];
        this.state = {
            showDetail: false, items: items, allItems: allItems,
            categorySize: categorySize
        };
        this.showCategory = this.showCategory.bind(this);
        this.itemAdded = this.itemAdded.bind(this);
        this.removeItem = this.removeItem.bind(this);
    }

    showCategory() {
        this.setState({showDetail: !this.state.showDetail});
    }

    itemAdded(itemId) {
        console.log("itemAdded=", itemId);
        if (!itemId) {
            this.setState({items: [], allItems: false});

            if (this.props.onChange) {
                this.props.onChange(this.props.category.id, []);
            }

        } else if (itemId === 'all') {
            this.setState({items: [], allItems: true});

            if (this.props.onChange) {
                this.props.onChange(this.props.category.id,
                    {id: this.props.category.id, name: this.props.category.get('name'), allItems: true});
            }

        } else {
            const newItems = [];
            itemId.split(",").forEach((chooseItem) => {
                console.log("select item = ", chooseItem);
                const item = this.props.category.getMenuItems().findWhere({id: Number(chooseItem)});
                if (item) {
                    newItems.push({id: item.id, name: item.get('name')})
                }
            });
            if(newItems.length === this.props.category.getMenuItems().length){
                this.setState({items: [], allItems: true});
                if (this.props.onChange) {
                    this.props.onChange(this.props.category.id,
                        {id: this.props.category.id, name: this.props.category.get('name'), allItems: true});
                }
                return
            }
            this.setState({items: newItems, allItems: false});
            if (this.props.onChange) {
                this.props.onChange(this.props.category.id,
                    {
                        id: this.props.category.id, name: this.props.category.get('name'),
                        allItems: false, items: newItems
                    });
            }
        }
    }

    removeItem(itemId) {
        const items = this.state.items.filter(i => i.id !== itemId);
        this.setState({items: items});

        if (this.props.onChange) {
            this.props.onChange(this.props.category.id,
                {
                    id: this.props.category.id, name: this.props.category.get('name'),
                    allItems: false, items: items
                });
        }
    }

    render() {
        const itemSelector = this.state.showDetail ?
            <ItemSelector items={this.props.category.getMenuItems()}
                          allItems={this.state.allItems}
                          chooseItems={this.state.items}
                          onAddItem={this.itemAdded}/> : null;
        const items = this.state.items.map(item =>
            <div style={{margin: 5, border: '1px solid black', padding: 5, borderRadius: 5, display: 'inline-block'}}>
                <span>{item.name}</span>
                <span style={{margin: '0 5px'}} onClick={() => this.removeItem(item.id)}>X</span>
            </div>);

        const categoryStyle = {
            color: 'black',
            border: '1px solid gainsboro',
            marginBottom: 10,
            padding: 5,
            borderRadius: 5
        };


        if (this.state.allItems) {
            categoryStyle.background = "#ceceff";
        }

        return (
            <div style={categoryStyle}>
                <div onClick={this.showCategory}>{this.props.category.get('name')}
                    ({this.state.allItems ? "全选" : this.state.items.length + "/" + this.state.categorySize})
                </div>
                <div style={{marginBottom: 10}}>
                    {itemSelector}
                </div>
            </div>
        )
    }
}

export default class MenuItemSelector extends Component {
    constructor(props) {
        super(props);
        let categories = {};

        if (props.categoryMap) {
            if (_.isObject(props.categoryMap)) {
                categories = props.categoryMap;

            } else {
                props.categoryMap.forEach(i, c => {
                    console.log(i, c);
                    categories[c.id] = c;
                });
            }

        }

        this.state = {categories: categories};
        this.onChange = this.onChange.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    onChange(categoryId, items) {
        this.state.categories[categoryId] = items;
        this.setState({categories: this.state.categories});
    }

    onClose() {
        if (this.props.onClose) {
            this.props.onClose(this.state.categories);
        }
    }

    render() {
        const categoryMap = this.state.categories;
        const categories = POS.getMenu().getCategories().map(cat => {
            const catConfig = categoryMap[cat.id];
            return <CategoryView
                category={cat} key={cat.cid}
                onChange={this.onChange}
                allItems={catConfig ? catConfig.allItems : false}
                items={catConfig ? catConfig.items : null}/>;
        });
        return (
            <Popup
                backgroundColor="white"
                title="选择折扣类别或餐品"
                onClose={this.onClose}>
                <div style={{height: 400, overflowY: 'scroll'}}>
                    {categories}
                </div>
            </Popup>
        );
    }
}


// WEBPACK FOOTER //
// ./src/react/common/MenuItemSelector.js